import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { IS_BROWSER } from 'src/utils'
import { getFilterParams, constructQueryParam } from 'src/deps'
import {
  userContainer,
  teamContainer,
  accountsContainer,
  customerContainer,
} from 'src/models'
import { Pagination, MetaDecorator } from 'src/views/components'
import { UserInvite } from './UserInvite'
import { UsersList } from './UsersList'
import { statuses } from './fixture'
import { i18nTranslate } from 'src/utils'
import {
  enableB2B2CUserInviteCreate,
  isenableUserInvite,
  enableAccountParticipantList,
} from 'src/utils'
import MicroFrontendLoader from 'src/views/components/MicroFrontends/MicroFrontendLoader'
import { scrollUtilities } from 'src/utils/customScrollManager'

@observer
class UserManagement extends React.Component {
  @observable isInviteUserVisible = false
  @observable activePage = 1
  @observable searchTeam = 'All'
  @observable searchRole = 'All'
  @observable searchUser = ''
  @observable isInvUserVisible = false
  async componentDidMount() {
    await this.fetchUserList(this.props)
    if (enableAccountParticipantList()) {
      scrollUtilities.scrollToTop('my-account-details-wrapper')
    }
  }

  componentWillUnmount() {
    enableB2B2CUserInviteCreate(false)
  }
  handleInviteUser = () => {
    this.isInviteUserVisible = !this.isInviteUserVisible
  }

  handleEnableForDashboard = () => {
    this.isInvUserVisible = isenableUserInvite()
    return this.isInvUserVisible
  }

  fetchUserList = async filterParams => {
    if (IS_BROWSER) {
      const queryParams = getFilterParams(location)
      const params = {
        page: queryParams.page || 1,
        ...filterParams,
      }
      this.activePage = parseInt(params.page)
      await teamContainer.getAllTeams()
      await teamContainer.getAllTeamsWithoutSize()
      await userContainer.getUsersList(params)
      await userContainer.getUserListWithoutSize()
    }
  }

  getSearchValue = searchOrFilterValue => {
    const defaultValue =
      searchOrFilterValue !== '' && searchOrFilterValue !== undefined
        ? searchOrFilterValue
        : 'All'
    return defaultValue
  }
  handleSearchAndFilter = filterData => {
    if (this.activePage !== 1) {
      const queryParams = this.props?.location?.queryParams || {}
      delete queryParams.page
      constructQueryParam(this.props, queryParams)
      this.activePage = 1
    }
    const { currentlySelectedType, team, role, searchUser } = filterData
    const params = {}

    if (currentlySelectedType === 'searchUser') {
      this.searchTeam = 'All'
      this.searchRole = 'All'
      params.searchUser = searchUser
    } else {
      this.searchUser = ''
      if (currentlySelectedType === 'team') {
        this.searchTeam = this.getSearchValue(team)
      }
      params.team = this.searchTeam !== 'All' ? this.searchTeam : ''
      if (currentlySelectedType === 'role') {
        this.searchRole = this.getSearchValue(role)
      }
      params.role = this.searchRole !== 'All' ? this.searchRole : ''
    }
    this.fetchUserList(params)
  }

  handleSearchChangeData = value => {
    this.searchUser = value
  }
  handlePagination = async pageNumber => {
    this.searchTeam = 'All'
    this.searchRole = 'All'
    this.searchUser = ''
    this.activePage = pageNumber
    const queryParams = getFilterParams(location)
    queryParams.page = pageNumber
    constructQueryParam(this.props, queryParams)
    this.fetchUserList(this.props)
  }
  renderAddParticipants = () => {
    const remoteConfig = {
      appName: 'account-profile',
      component: 'AddParticipants',
    }
    return (
      <div className="user-menu-mfe-wrapper">
        <MicroFrontendLoader remoteConfig={remoteConfig} />
      </div>
    )
  }
  renderAccountPartcipantList = () => {
    const remoteConfig = {
      appName: 'account-profile',
      component: 'ParticipantList',
    }
    return (
      <div className="user-menu-mfe-wrapper">
        <MicroFrontendLoader remoteConfig={remoteConfig} />
      </div>
    )
  }
  render() {
    const teamOptions = teamContainer?.teamsDataWithoutSize?.teams || []
    const buyerRoles = accountsContainer.buyerRoles
    const pageableInfo =
      userContainer?.userDataWithPaginationInfo?.pageableInfo || {}
    const { size = 0, totalCount = 0 } = pageableInfo
    const defaultSearchAndFilterValue = {
      searchTeam: this.searchTeam,
      searchRole: this.searchRole,
      searchUser: this.searchUser,
    }
    let isInUserVisible = isenableUserInvite()
    if (isInUserVisible === false) {
      isInUserVisible = this.isInviteUserVisible
    }
    const myAccountUserManagementTitle = i18nTranslate(
      'myAccountUserManagementPage.title',
      'Associates | Nu Skin'
    )
    return (
      <React.Fragment>
        <MetaDecorator
          title={myAccountUserManagementTitle}
          imageUrl=""
          imageAlt=""
          description="User Management Page"
          location={this.props}
        />
        {this.handleEnableForDashboard && isInUserVisible && (
          <UserInvite
            teams={teamOptions}
            roles={buyerRoles}
            handleInviteUser={this.handleInviteUser}
          />
        )}
        {enableAccountParticipantList() ? (
          <>
            {this.renderAddParticipants()}
            {this.renderAccountPartcipantList()}
          </>
        ) : (
          <>
            <UsersList
              usersData={userContainer.userData}
              teams={teamOptions}
              statuses={statuses}
              roles={buyerRoles}
              handleSearchChangeData={this.handleSearchChangeData}
              defaultSearchAndFilterValue={defaultSearchAndFilterValue}
              handleSearchAndFilter={this.handleSearchAndFilter}
              handleInviteUser={this.handleInviteUser}
              isInvUserVisible={isInUserVisible}
              isInviteUserVisible={this.isInviteUserVisible}
            />
            {totalCount > size && (
              <Pagination
                handlePagination={this.handlePagination}
                totalPages={Math.ceil(totalCount / size)}
                active={this.activePage}
              />
            )}
          </>
        )}
      </React.Fragment>
    )
  }
}

export { UserManagement }

export default UserManagement
